import {ChatDetails} from '@buncha/AboutShift/types';

export interface User {
  readonly id: string;
  readonly name?: string;
  readonly email?: string | string[] | null;
  readonly phone?: string | string[] | null;
  readonly welcomeMessage?: string | null;
  readonly photoUrl?: string | null;
  readonly role?: string | null;
  readonly configuration?: string | null;
  readonly custom?: {
    [name: string]: string | null;
  } | null;
  readonly availabilityText?: string | null;
  readonly locale?: string | null;
}

export interface CurrentUser {
  id: number;
  chatUser: User;
  phoneNumber: string;
}

export interface GetChatInfoResponse {
  currentUser: CurrentUser;
}

export interface GetChatDetailsResponse {
  getRun: ChatDetails;
}

// eslint-disable-next-line no-shadow
export enum ConversationAccess {
  None = 'None',
  Read = 'Read',
  ReadWrite = 'ReadWrite',
}
export interface ChatParticipant {
  access: ConversationAccess;
  user: {
    id: number;
    lastName: string;
    firstName: string;
    phoneNumber: string;
  };
}

export interface Conversation {
  id: string;
  subject: string;
  custom: any;
  photoUrl: string;
}

export interface GetConversationById {
  getConversationById: {
    data: {
      conversation: Conversation;
    };
  };
}

export interface GetConversationParticipants {
  getConversationParticipants: {
    data: {
      participant: ChatParticipant[];
    };
  };
}

// eslint-disable-next-line no-shadow
export enum ChatModes {
  group = 'group',
  run = 'run',
  order = 'order',
}

// eslint-disable-next-line no-shadow
export enum ChatFilterName {
  operationFilter = 'operationFilter',
  orderFilter = 'orderFilter',
}

export declare type NumberPredicate =
  | ['>' | '<' | '>=' | '<=', number]
  | ['between' | '!between', [number, number]];

export declare type FieldPredicate<T> =
  | ['==' | '!=', T]
  | ['oneOf' | '!oneOf', T[]];

export declare type CustomFieldPredicate =
  | FieldPredicate<string>
  | 'exists'
  | '!exists';

export declare interface SenderPredicate {
  id?: FieldPredicate<string>;
  locale?: FieldPredicate<string>;
  role?: FieldPredicate<string>;
  custom?: {
    [key: string]: CustomFieldPredicate;
  };
}

export declare interface MessagePredicate {
  sender?: SenderPredicate;
  type?: FieldPredicate<'UserMessage' | 'SystemMessage'>;
  origin?: FieldPredicate<'web' | 'rest' | 'email' | 'import'>;
  custom?: {
    [key: string]: CustomFieldPredicate;
  };
  createdAt?: NumberPredicate;
}

export interface ChatParams {
  userId: string;
  conversationId: string;
  messageFilter: MessagePredicate | undefined;
  customData: any;
  chatKey: string;
  message?: string;
  platform: string;
}

export interface ConversationParams {
  userId: string;
  chatKey: string;
  platform: string;
  feedFilter: any;
}
